export const primaryColor = "#fefefe"
export const secondaryColor = "#000000"
export const secondaryDarkColor = "#4b4b4b"
export const colorOverBody = "white"